module.exports = __WEBPACK_EXTERNAL_MODULE_340__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx","Observable","prototype"],"commonjs":"rxjs/operator/switchMap","commonjs2":"rxjs/operator/switchMap","amd":"rxjs/operator/switchMap"}
// module id = 340
// module chunks = 0 1